import { createSlice } from "@reduxjs/toolkit";
import {
  toAddSurvey,
  toAddSurveyResponse,
  toGetSurvey,
} from "../actions/survey.actions";

const initialState = {
  survey: [] as any,
  surveyRequest: {} as any,
  surveyResponse: {
    loading: false,
    data: {} as any,
    error: null as unknown | null,
  },
  loading: false,
  isLoading: false,
  error: null as unknown | null,
  targeted: [] as any,
  type:"",
};
export const surveySlice = createSlice({
  name: "survey",
  initialState: initialState,
  reducers: {
    setTargeted: (state, action) => {
      state.targeted = action.payload;
    },
    setType: (state, action) => {
      state.type = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(toGetSurvey.pending, (state) => {
        state.loading = true;
      })
      .addCase(toGetSurvey.fulfilled, (state, action) => {
        state.survey = action.payload;
        state.loading = false;
      })
      .addCase(toGetSurvey.rejected, (state, action) => {
        state.survey = [];
        state.loading = false;
        state.error = action.payload;
      });
    //Add survey
    builder
      .addCase(toAddSurvey.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(toAddSurvey.fulfilled, (state, action) => {
        state.surveyRequest = action.payload;
        state.isLoading = false;
      })
      .addCase(toAddSurvey.rejected, (state, action) => {
        state.surveyRequest = [];
        state.isLoading = false;
        state.error = action.payload;
      });
    //Add survey sponsors and Beneficiaries
    builder
      .addCase(toAddSurveyResponse.pending, (state) => {
        state.surveyResponse.loading = true;
      })
      .addCase(toAddSurveyResponse.fulfilled, (state, action) => {
        state.surveyResponse.data = action.payload;
        state.surveyResponse.loading = false;
      })
      .addCase(toAddSurveyResponse.rejected, (state, action) => {
        state.surveyResponse.data = [];
        state.surveyResponse.loading = false;
        state.surveyResponse.error = action.payload;
      });
  },
});
export const { setTargeted,setType } = surveySlice.actions;
export default surveySlice.reducer;
